import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  UserCommission: [],
  UserPopulate: [],
  CommissionSummary: [],
  ProjectCommission: [],
  AfffiliatePerformance: [],
  MonthYearCommission: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status1: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status2: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status3t: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status5: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status4: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status6: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status7: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'

  error: null,
  IsLogin: true,
};

export const fetchUserCommission = createAsyncThunk("/Reports/UsercommissionReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/UserCommissionReport?startDate=${data?.from}&endDate=${data?.to}&userId=${
      data?.userId ? data?.userId : ""
    }&status=${data?.status ? data?.status : ""}`
  );
  return response.data;
});
export const fetchCommissionSummary = createAsyncThunk("/Reports/commissionSummaryReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/CommissionReport?startDate=${data?.from}&endDate=${data?.to}&userId=${
      data?.userId ? data?.userId : ""
    }&status=${data?.status ? data?.status : ""}`
  );
  return response.data;
});
export const fetchProjectCommission = createAsyncThunk("/Reports/ProjectCommissionReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/ProjectWiseCommissionReport?startDate=${data?.from}&endDate=${data?.to}&projectId=${
      data?.projectId ? data?.projectId : ""
    }&sectionId=${data?.sectionId ? data?.sectionId : ""}&status=${data?.status ? data?.status : ""}`
  );
  return response.data;
});
export const fetchAfffiliatePerformance = createAsyncThunk("/Reports/AfffiliatePerformanceReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/AffiliatePerformanceReport?startDate=${data?.from}&endDate=${data?.to}&affiliateId=${
      data?.userId ? data?.userId : ""
    }&status=${data?.status ? data?.status : ""}`
  );
  return response.data;
});
export const fetchMonthYearCommission = createAsyncThunk("/Reports/MonthYearCommissionReport", async data => {
  const response = await axiosInstance.get(
    `/Reports/MonthlyYearlyCommissionReport?groupBy=${data?.from}&filterYear=${data?.to}&headName=${
      data?.userId ? data?.userId : ""
    }`
  );
  return response.data;
});
export const fetchUserPopulate = createAsyncThunk("/Reports/Userpopulate", async () => {
  const response = await axiosInstance.get(`/Reports/UserPopulate`);
  return response.data;
});
const CommissionReportSlice = createSlice({
  name: "CommissionReports",
  initialState,
  reducers: {
    ReportsAdded: {
      reducer(state, action) {
        state.UserCommission?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchUserCommission.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchUserCommission.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserCommission = action.payload.Data;
      })
      .addCase(fetchUserCommission.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchUserPopulate.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchUserPopulate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserPopulate = action.payload.Data;
      })
      .addCase(fetchUserPopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchCommissionSummary.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchCommissionSummary.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.CommissionSummary = action.payload;
      })
      .addCase(fetchCommissionSummary.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchProjectCommission.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchProjectCommission.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.ProjectCommission = action.payload;
      })
      .addCase(fetchProjectCommission.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchAfffiliatePerformance.pending, state => {
        state.status2 = "loading";
      })
      .addCase(fetchAfffiliatePerformance.fulfilled, (state, action) => {
        state.status2 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.AfffiliatePerformance = action.payload.Data;
      })
      .addCase(fetchAfffiliatePerformance.rejected, (state, action) => {
        state.error = action.error.message;
        state.status2 = "failed";
      })
      .addCase(fetchMonthYearCommission.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchMonthYearCommission.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.MonthYearCommission = action.payload.Data;
      })
      .addCase(fetchMonthYearCommission.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getCommissionReportsDetails = state => state.CommissionReports;

export const { ReportsAdded } = CommissionReportSlice.actions;

export default CommissionReportSlice.reducer;
